import React from "react";
import Select from "react-select";
import { checkNull } from "../../helpers";

const GroupMultiSelect = (props) => {
  const {
    label = "",
    name = "",
    empty = "Select",
    divClass = "input-group",
    labelClass = "",
    multiple = true,
    options=[],
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      {checkNull(label, false) && <label className={labelClass}>{label}</label>}
      <div className={`${divClass}`}>
        <Select name={name} id={props?.id ?? name} isMulti={multiple} options={options} {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupMultiSelect;
